import { mainnet, sepolia, base } from "wagmi/chains";
import type { Address } from "viem";

// Fill these in after `npm run contracts:deploy:mainnet` (and any other chains).
// All-zero address = "not deployed yet" — the UI will show a placeholder state.
export const GAIA_ADDRESS: Record<number, Address> = {
  [mainnet.id]: (import.meta.env.VITE_GAIA_ADDRESS_MAINNET ?? "0x0000000000000000000000000000000000000000") as Address,
  [base.id]:    (import.meta.env.VITE_GAIA_ADDRESS_BASE    ?? "0xD904F3dA69Cd2fC768E752d618c7C74aBE98D6C4") as Address,
  [sepolia.id]: (import.meta.env.VITE_GAIA_ADDRESS_SEPOLIA ?? "0x30bd231c010b2d377A32102AE072D93EE1EA892B") as Address,
};

// Default chain when nothing is connected.
// GAIA lives on BASE — both Sepolia (testnet) and Base (mainnet) are live.
export const DEFAULT_CHAIN_ID = base.id;

export const PROFIT_WALLET = "0x7cEcCA8e5f3596b598C3f01fB9dB1759ed676614" as Address;

export function isDeployed(chainId: number): boolean {
  const a = GAIA_ADDRESS[chainId];
  return !!a && a !== "0x0000000000000000000000000000000000000000";
}

export function explorerTx(chainId: number, hash: string): string {
  if (chainId === mainnet.id) return `https://etherscan.io/tx/${hash}`;
  if (chainId === sepolia.id) return `https://sepolia.etherscan.io/tx/${hash}`;
  if (chainId === base.id) return `https://basescan.org/tx/${hash}`;
  return `https://etherscan.io/tx/${hash}`;
}

export function explorerAddress(chainId: number, addr: string): string {
  if (chainId === mainnet.id) return `https://etherscan.io/address/${addr}`;
  if (chainId === sepolia.id) return `https://sepolia.etherscan.io/address/${addr}`;
  if (chainId === base.id) return `https://basescan.org/address/${addr}`;
  return `https://etherscan.io/address/${addr}`;
}
